import { Icon } from '@whitbread-eos/atoms';
import { formatAssetsUrl, getSecureTwoURL } from '@whitbread-eos/utils';
import { useEffect, useRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export function getListOfLanguagesForSwitcher(countries) {
  var countriesForSwitcher = countries.map(country => {
    var isEnglishLanguage = country.language === 'English';
    return {
      locale: isEnglishLanguage ? 'en' : 'de',
      languageName: country.language,
      icon: _jsx(Icon, {
        src: formatAssetsUrl(country.flagUrl),
        alt: country.language,
        cursor: "pointer",
        "data-testid": isEnglishLanguage ? 'britishFlag' : 'germanFlag'
      })
    };
  });
  return countriesForSwitcher;
}
export var isBusinessPage = pathname => {
  var businessPaths = ['/business.html', '/business-blog.html', '/business/meeting-rooms.html', '/business/new-hotels-for-business.html', '/business/travel-partners.html', '/business/business-termsandconditions.html', '/business/business-form.html', '/faq/business.html'];
  return businessPaths.some(path => pathname.includes(path));
};
export var getPibLoginRedirectUrl = (domain, language, country) => {
  return "".concat(domain, "/").concat(language && country ? "".concat(language, "-").concat(country) : 'en-gb', "/account/login?intcmp=piLogInModalLink");
};
export var getSecureTwoOrigin = () => {
  var rawSecureTwoUrl = getSecureTwoURL();
  return rawSecureTwoUrl && rawSecureTwoUrl.startsWith('http') ? new URL(rawSecureTwoUrl).origin : "".concat(window.location.protocol, "//").concat(rawSecureTwoUrl).replace(/\/$/, '');
};
export function useLogoutWithRedirect(country, language, isAuth0Active, navigateToLogout) {
  var pendingLogoutRef = useRef(false);
  var pendingReasonRef = useRef('');
  var homeUrl = "/".concat(country, "/").concat(language, "/home.html");
  useEffect(() => {
    if (isAuth0Active) return;
    var handleMessages = message => {
      var _message$data;
      var action = typeof (message === null || message === void 0 ? void 0 : message.data) === 'string' ? message.data : (_message$data = message.data) === null || _message$data === void 0 ? void 0 : _message$data.action;
      if (action === 'USER_LOG_OUT' && message.origin === window.location.origin) {
        var _message$data$reason, _message$data2;
        pendingLogoutRef.current = true;
        pendingReasonRef.current = typeof message.data === 'string' ? '' : (_message$data$reason = (_message$data2 = message.data) === null || _message$data2 === void 0 ? void 0 : _message$data2.reason) !== null && _message$data$reason !== void 0 ? _message$data$reason : '';
        var authIframe = document.getElementById('authIframe');
        if (authIframe !== null && authIframe !== void 0 && authIframe.contentWindow) {
          authIframe.contentWindow.postMessage(JSON.stringify({
            action: 'logout'
          }), getSecureTwoOrigin());
        }
      }
      if (action === 'userLoggedOut' && message.origin === getSecureTwoOrigin() && pendingLogoutRef.current) {
        pendingLogoutRef.current = false;
        if (pendingReasonRef.current === 'SESSION_EXPIRED') {
          window.location.assign("".concat(homeUrl, "?sessionExpired=true"));
        } else {
          window.location.assign(homeUrl);
        }
        pendingReasonRef.current = '';
      }
    };
    window.addEventListener('message', handleMessages);
    return () => window.removeEventListener('message', handleMessages);
  }, [country, language, isAuth0Active]);
  return () => {
    if (isAuth0Active) {
      navigateToLogout("".concat(window.location.origin).concat(homeUrl));
      return;
    }
    var authIframe = document.getElementById('authIframe');
    if (authIframe !== null && authIframe !== void 0 && authIframe.contentWindow) {
      pendingLogoutRef.current = true;
      pendingReasonRef.current = '';
      authIframe.contentWindow.postMessage(JSON.stringify({
        action: 'logout'
      }), getSecureTwoOrigin());
    }
  };
}